import React from "react";

const PageNotFound: React.FC = () => {

    return (
        <>
            <p>
                404 page not found
            </p>
        </>
    )
};

export default PageNotFound;